import type {Tag} from 'shells/tags-editor/tags-editor';

import type {TagType} from 'nutshell-graphql-types';
import type {
    TagFragment,
    GetContactInfo_contact_tagMaps_edges as TagMapEdge,
} from 'nutshell-graphql-types';

export const castGraphqlTagsToTagType = (tags: TagFragment[]): Tag[] => {
    return tags.map((tag: TagFragment) => {
        return {
            id: tag.id,
            name: tag.name,
            color: tag.color,
            creator: tag.creator,
            createdTime: tag.createdTime,
        };
    });
};

export const translateTagTypeToHumanReadable = (tagType: TagType) => {
    switch (tagType) {
        case 'ACCOUNT':
            return 'Company';
        case 'CONTACT':
            return 'Person';
        case 'LEAD':
        default:
            return 'Lead';
    }
};

export const getTagsFromTagMapEdges = (tagMapEdges: TagMapEdge[]): Tag[] => {
    // @ts-expect-error
    return tagMapEdges.map((edge) => ({
        ...edge.node,
        creator: edge.creator,
        createdTime: edge.createdTime,
    }));
};
